import {Component, HostBinding, Input, OnChanges, OnInit} from '@angular/core';
import {Constants} from '../../constants';

@Component({
  selector: 'app-condition-row',
  templateUrl: './condition-row.component.html',
  styleUrls: ['./condition-row.component.scss']
})
export class ConditionRowComponent {
  @HostBinding('class.condition-row') conditionRow = true;
  @Input() row: any;
  @Input() index: any;
  constructor() { }
  get conditions() {
    return this.row ? this.row.conditions : [];
  }
  toggleOperator() {
    this.row.logicalConnector = this.row.logicalConnector === Constants.LOGICAL_AND ?
      Constants.LOGICAL_OR : Constants.LOGICAL_AND;
  }
  isOrOperator() {
    return this.row.logicalConnector === Constants.LOGICAL_OR;
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/condition-row/condition-row.component.ts